// Custom lazyload video element
if ('IntersectionObserver' in window) { // Detect support for IntersectionObserver
  const lazyloadVideo = '.js-lazyload-video' // Define observed targets
  const targets = document.querySelectorAll(lazyloadVideo)
  // Observer
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { // Deal with every intersection
        if (entry.target.hasAttribute('data-poster')) { // May be we have no poster defined, e.g. for background video
          entry.target.setAttribute('poster', entry.target.dataset.poster) // Swap in the poster src
          entry.target.removeAttribute('data-poster') // Remove data-poster (for the sake of clarity)
        }
        // console.log(entry.target.children) // All the children
        for (let i = 0; i < entry.target.children.length; i++) { // Loop through source entries
          entry.target.children[i].src = entry.target.children[i].dataset.src // Swap in the appropriate video src
          entry.target.load() // Yay! Load the video!!
          entry.target.dataset.loaded = true // Declare this was loaded...
          entry.target.children[i].removeAttribute('data-src') // Remove data-src (for the sake of clarity)
        }
        observer.unobserve(entry.target) // Remove observer if intersection took place, so this is carried out only once per video
      }
    })
  })
  // Observe targets
  targets.forEach(target => {
    observer.observe(target)
  })
}
